import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import findDayEntity, {openingHoursStringFromEntity} from '../../../../calendar/calendar-context.js';

class CalendarOfficeHours extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDayEntity: findDayEntity(props.selectedDay),
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedDay !== this.props.selectedDay) {
      this.setState({
        selectedDayEntity: findDayEntity(this.props.selectedDay),
      })
    }
  }

  render() {
    return (
      <div className="component component-office-hours">
        <div className="time">{this.props.t('Öffnungszeiten')}: {this.props.t(openingHoursStringFromEntity(this.state.selectedDayEntity))}</div>
      </div>
    )
  }
}

CalendarOfficeHours.propTypes = {
  selectedDay: PropTypes.string.isRequired
};

export default withTranslation()(CalendarOfficeHours);
